import { useOfficeComponentContext } from '@office-start/component-context-service';
import { usePrevious } from '@office-start/hooks-utility';
import { useIdentity } from '@office-start/identity-service';
import { useLocStrings } from '@office-start/loc-service';
import { getDefaultHeaderText, useShellConfig, } from '@office-start/shell-config-service';
import { useShellShimReact } from '@office-start/shell-shim-service';
import { HarmonyThemeType } from '@office-start/theming-types';
import { useUserEntitlements } from '@office-start/user-entitlements-service';
import { useEffect, useMemo } from 'react';
import { useHarmonyThemeData } from './useHarmonyThemeData';
var emptyString = '';
var useIsDesktopApp = function () {
    var _a, _b;
    var entitlements = (_b = (_a = useUserEntitlements()) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.result;
    if (!entitlements) {
        return false;
    }
    return (entitlements.isPwaInWebView2 ||
        entitlements.isPwaInUwp ||
        entitlements.isPwa // Treat PWA as desktop app
    );
};
var useDefaultHelpNamespace = function () {
    var _a;
    var identity = (_a = useIdentity()) === null || _a === void 0 ? void 0 : _a.data;
    var isDesktopApp = useIsDesktopApp();
    return useMemo(function () {
        if (isDesktopApp) {
            return (identity === null || identity === void 0 ? void 0 : identity.isMsa) ? 'MSAPWA' : 'IWPWA';
        }
        return (identity === null || identity === void 0 ? void 0 : identity.isMsa) ? 'IWAPPC' : 'IWAPP';
    }, [identity, isDesktopApp]);
};
export var useUpdateShellHeader = function () {
    var _a, _b;
    var shellShim = useShellShimReact();
    var shellConfig = (_a = useShellConfig()) === null || _a === void 0 ? void 0 : _a.data;
    var locStrings = (_b = useLocStrings()) === null || _b === void 0 ? void 0 : _b.data;
    var isDesktopApp = useIsDesktopApp();
    var defaultHelpNamespace = useDefaultHelpNamespace();
    var context = useOfficeComponentContext().data;
    var harmonyThemeData = useHarmonyThemeData();
    var previousThemeData = usePrevious(harmonyThemeData);
    useEffect(function () {
        if (!harmonyThemeData ||
            !locStrings ||
            !shellShim ||
            !shellConfig ||
            !context) {
            return;
        }
        if (harmonyThemeData.type === HarmonyThemeType.App) {
            // If on an app theme, update the header text and help namespace
            var headerLink = locStrings.edgeworthResources[harmonyThemeData.headerResources.edgeworthResourcesTitleKey];
            shellShim.Header.UpdateHeaderLink(headerLink, emptyString /* URL */);
            shellShim.NFD.UpdateHelpNamespace(harmonyThemeData.headerResources.helpNamespace);
        }
        else if (previousThemeData &&
            previousThemeData.type === HarmonyThemeType.App) {
            // No longer on app theme, reset the header link and help namespace
            shellShim.NFD.UpdateHelpNamespace(defaultHelpNamespace);
            if (isDesktopApp &&
                (harmonyThemeData.type !== HarmonyThemeType.Shell ||
                    (harmonyThemeData.type === HarmonyThemeType.Shell &&
                        harmonyThemeData.themeType !== 'Tenant'))) {
                // Remove the header text when in desktop app on non-shell themes
                // and, for shell themes, when it is not a tenant theme.
                shellShim.Header.UpdateHeaderLink(emptyString, emptyString /* URL */);
            }
            else {
                // Otherwise, put back the homePageTitle in the header text
                shellShim.Header.UpdateHeaderLink(getDefaultHeaderText(context, locStrings), emptyString /* URL */);
            }
        }
    }, [
        defaultHelpNamespace,
        harmonyThemeData,
        isDesktopApp,
        locStrings,
        previousThemeData,
        shellConfig,
        shellShim,
        context,
    ]);
};
//# sourceMappingURL=useUpdateShellHeader.js.map